<template>
    <v-container fluid>
      <div id="app " >
        <v-row>
          <v-col cols="11">
            <Breadcrumb class="row justify-content-center mt-4"/>
          </v-col>
          <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
          </v-col>
        </v-row>    
      </div>   
      <v-data-table
        ref="theDataTable"
        :headers="headersData"
        :items="operatorsData"
        :items-per-page="6"   
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
  
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px">
              <template v-slot:activator="{ on, attrs }">
                              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="50"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class=""
                      outlined
                      fab
                      small
                      color="#0C479D"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>icon-download</v-icon>
                    </v-btn>
                  </template>
  
                  <v-card>
  
                    <v-divider></v-divider>
  
                    <v-list>
                      <v-list-item>
                        <v-list-item-action>
                          <vue-json-to-csv
                            :json-data="dataDownload"
                            :csv-title="'Admin Access Request Data'"
                          >
                            <v-btn color="indigo" dark style="">
                              CSV
                            </v-btn>
                          </vue-json-to-csv>
  
                        </v-list-item-action>
                      </v-list-item>
  
                      <v-list-item>
                        <v-list-item-action>
                          <v-btn @click="createPDF" color="indigo" dark
                            >PDF
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <v-btn
                  class="mr-2"
                  outlined
                  small
                  fab
                  color="#0C479D"
                  v-bind="attrs"
                  v-on="on"
                  @click="getAccessName"
                  :disabled="addDisable"
                >
                  <v-icon>icon-add</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container id="container">
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          :items="inputData.items"
                          v-model="inputData.selectedId"
                          :prepend-icon="inputData.icon"
                          :label="inputData.label"
                          :item-text="inputData.itemText" 
                          :item-value="inputData.itemValue"
                          dense
                        ></v-autocomplete>
                      <div style="display:flex">
                        <DateTimeSelector @datesSelected="onDatesSelected" :params="paramFrom"/>
                        <DateTimeSelector @datesSelected="onDatesSelected" :params="paramTo"/>
                      </div>  
                        <v-form @submit.prevent="submitForm" id="form">
                          <v-textarea
                            label="Reason"
                            v-model="reason"
                            :rules="[v => !!v || 'Reason is required']"
                          ></v-textarea>
                          <br />
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
  
                <v-card-actions class="pb-5">
                  <v-spacer></v-spacer>
                  <v-btn outlined rounded color="error" @click="close">
                    <v-icon left>icon-cancel</v-icon>
                    Cancel
                  </v-btn>
                  <v-btn rounded color="primary" @click="adminAccessRequestDataEntry">
                    <v-icon left>icon-availability</v-icon>
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
  
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            icon-action
          </v-icon>
        </template>
        <template v-slot:item.enable_status="{ item }">
          <v-switch
            color="indigo"
            @change="changeStatus(item, item.enable_status)"
            false-value="N"
            true-value="Y"
            v-model="item.enable_status"
          ></v-switch>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="setGridData"> Reset </v-btn>
        </template> -->
      </v-data-table>
          <div id="sucessAlert">
        <v-alert outlined type="success" text> Data Saved successfully. </v-alert>
      </div>
      <div id="errorAlert">
        <v-alert outlined type="warning" prominent border="left">
          Error while saving the data.
        </v-alert>
      </div>
    </v-container>
  </template>
  <script>
  import DateTimeSelector from "../components/datetimeselector.vue";
  import LoaderProgress from "../components/progressLoader";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  import axios from "axios";
  import router from "../router";
  import VueJsonToCsv from "vue-json-to-csv";
  import Breadcrumb from "../components/breadcrumbs.vue";
  
  export default {
    components: {
      DateTimeSelector,
      LoaderProgress,
      Breadcrumb,
      VueJsonToCsv
    },
    mounted() {
      document.querySelector("#errorAlert").style.display = "none";
      document.querySelector("#sucessAlert").style.display = "none";
      this.getAdminAccessRequestData()
      this.tomorrow()
      this.fromUnixTs = Date.parse(new Date().toISOString().substr(0, 10) + " " + "00:00") / 1000;
      this.toUnixTs = Date.parse(new Date().toISOString().substr(0, 10) + " " + "00:00") / 1000;
      // this.$refs.form.reset();
    },
    data() {
      return {
        addDisable:false,
        menu:null,
        formTitle:"Admin Access Request",
        dialog: false,
        search:"",
        headersData : [
          {
            text: "Access Name",
            value: "access_name",
            sortable: true,
          },
          {
            text: "Approval Status",
            value: "approval_status",
            sortable: true,
          },
          {
            text: "From Date",
            value: "from_date",
            sortable: true,
          },
          {
            text: "To Date",
            value: "to_date",
            sortable: true,
          },
          {                                    
            text: "Reason",
            value: "reason",    
            sortable: true,
  
          },                                   
          {
            text: "Username",
            value: "user_name",
            sortable: true,
          },
        ],
        inputData: {
          icon: "mdi-account",
          label: "Access Type",
          itemText: "access_name", // Replace "name" with the field name to display in the dropdown
          itemValue: "id", // Replace "key" with the field name that contains the key (value)
          items:[],
          selectedId:""
        },
        reason: null,
        paramFrom: {
          defaultTime: new Date().toISOString().substr(0, 10),
          dateLabel: "From Date",
          from: true,
        },
        paramTo: {
          defaultTime: new Date().toISOString().substr(0, 10),
          dateLabel: "To Date",
          from: false,
        },
        fromUnixTs:null,
        toUnixTs:null,
        showLoader:false,
        operatorsData: [],
        dataDownload: [],
        pagination: {
        pageStart: 0,
        pageStop: 0,
      },
      };
    },
    methods: {
      close(){
        this.dialog = false
        this.tomorrow()
        this.reason = ""
        // console.log("inside close")
      },
      tomorrow() {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate()); //add +1 after testing
        this.paramFrom.defaultTime = tomorrow.toISOString().substr(0, 10)
        this.paramTo.defaultTime = tomorrow.toISOString().substr(0, 10)
      },
      onDatesSelected({ from, date }) {
        if (from) {
          let fromDate = date
          // console.log("Selected From Date:", fromDate);
          this.fromUnixTs = Date.parse(fromDate) / 1000;
          // console.log("unix ts", this.fromUnixTs);
        } else {
          let toDate = date;
          // console.log("Selected to Date:", toDate);
          this.toUnixTs = Date.parse(toDate ) / 1000;
        }
      },
  
      getAccessName(){
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/accessnames`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        axios(config).then((response) => {
          // console.log("response from access names",response.data.data);
          this.inputData.items = response.data.data
          if (this.inputData.items.length == 1) {
            this.inputData.selectedId = this.inputData.items[0].id
          }
        });
      },
       getAdminAccessRequestData(){
        this.showLoader = true;
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getuseradminaccessrequestdata`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        axios(config).then((response) => {
          this.showLoader = false;
          try {
            let result = []
            // console.log(response.data);
            this.operatorsData = response.data.table_data
            this.addDisable = response.data.role_changed_status
            // console.log("operational data",this.operatorsData)
            for (let i in response.data) result.push([i, response.data[i]]);
            // console.log("checking result data=>", result[0][1]);
            this.dataDownload = result[0][1];
            this.showLoader = false;
          } catch (error) {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            }
            // console.log("error at getAdminAccessRequestData method",error)
          }
  
        });
      },
      adminAccessRequestDataEntry() {
        this.showLoader = true
        this.addDisable = true
        this.dialog = false
        let req = {
          fromUnixTs:this.fromUnixTs,
          toUnixTs:this.toUnixTs,
          requestAccessId:this.inputData.selectedId,
          reason: this.reason
        }
        // console.log("req",req)
        // console.log(this.selectedItem); 
        let config = {
          method: "post",
          url: `${this.$config.backend_url}/adminaccessrequestdataentry`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req
        };
        this.noteLastAPICallTime();
        axios(config).then((response) => {
          // console.log("insert respose",response.data);
          if (response.data.status == true) {
            document.querySelector("#sucessAlert").style.display = "block";
            this.getAdminAccessRequestData()
            this.close()
          } else {
            let message = response.data.message
            console.log("response messgae",response.data)
            alert(message)
            document.querySelector("#errorAlert").style.display = "block";
            this.showLoader = false
            this.addDisable = false
          }
        });
      },
      createPDF() {
        let content = this.$refs["theDataTable"];
        // console.log("pagination", this.pagination);
        let doc = new jsPDF();
        doc.text(14, 7.5, "Admin Access Request");
         doc.addImage(
          this.getImgUrl1(this.$config.image_inside_pdf),
          "png",
          this.$config.first_dimension_separate_again,
          this.$config.second_dimension_separate,
          this.$config.third_dimension_separate,
          this.$config.fourth_dimension_separate_again
        );
        let columnHeaders = ["Access Name","Approval status","from date", "to date", "Reason"];   // sujan(added duration column)
        let rows = [];
        content.items.forEach((data, index) => {
          if (
            index >= this.pagination.pageStart &&
            index < this.pagination.pageStop
          ) {
            let tempRow = [
              data.machine_name || "",
              data.topic_name || "",
              data.enable_status === "Y" ? "On" : "Off",
              data.duration_value || "",     // sujan(added duration column)
              data.device_name || "",
            ];
            rows.push(tempRow);
          }
        });
        doc.setFontSize(9);
        doc.autoTable(columnHeaders, rows, { startY: 11.5 });
        let d = new Date();
        doc.save(
          `AdminAccessRequestData ${d.toISOString().slice(0, 10) +
            " " +
            d
              .toTimeString()
              .split("(")[0]
              .slice(0, -1)}.pdf`
        );
      },
    },
  };
  </script>
  
  <style scoped>
  #form {
    padding-top: 2%;
  }
  #container {
    margin-top: 2%;
  }
  </style>